module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/scal360/view-scal360-license-information/view-scal360-license-information.component.css
// module id = 996
// module chunks = 1